<div class="row">
    <div class="col-md-12">
        <iframe src="https://www.wikipoint.co/story/direkt?nav=sec&page=360hs&rchange=true&roomid=1&pageId=6887"
            class="ifram-screen" frameborder="0" allowfullscreen>
        </iframe>
    </div>
</div>